// extracted by mini-css-extract-plugin
module.exports = {"listCaseItem":"CaseItem_listCaseItem_2T5w3","brandList":"CaseItem_brandList_2Uo-_"};